import React, { useEffect } from "react";
import Slider from "react-slick";
import { GetBrandsData } from "components/ApiServices/GetBrands";
import { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GatsbyImage } from "gatsby-plugin-image";

const LogoCarousel = (...props) => {

  const getLogosData = GetBrandsData();
  const [slider, setSlider] = useState();

  const renderArrows = () => {
    return (
      <div className="arrows">
        <div className="container">
          <div
            onClick={() => slider.slickNext()}
            className="next cursor-pointer"
          >
            <span className="pe-7s-angle-right"></span>
          </div>
          <div
            onClick={() => slider.slickPrev()}
            className="prev cursor-pointer"
          >
            <span className="pe-7s-angle-left"></span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section
      className={`brands-testimonials pt-0 testimonials ${props[0].withIMG
        ? "bg-img"
        : props[0].withCOLOR
          ? "section-padding back-color"
          : props[0].noPadding
            ? ""
            : "section-padding"
        } ${props.classText ? props.classText : ""}`}
      style={{
        backgroundImage: `${props[0].withIMG ? "url(/img/testim-img.jpg)" : "none"
          }`,
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="sec-head  text-center">
              <h6 className="wow fadeIn" data-wow-delay=".5s">
                Trusted by Leading Brands
              </h6>
              <h3 className="wow color-font">
                We’re proud to collaborate with innovative companies across the globe, delivering results that drive growth.
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid position-re">
        <div className="row wow fadeInUp" data-wow-delay=".5s">
          <div className="col-lg-12">
            <Slider
              className="slic-item"
              {...{
                ref: (c) => setSlider(c),
                dots: false,
                infinite: true,
                arrows: true,
                centerMode: true,
                autoplay: false,
                rows: 1,
                slidesToScroll: 1,
                slidesToShow: 5,
                centerPadding: 0,
                variableWidth: true,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 5,
                      centerMode: true,
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 3,
                      centerMode: true,
                      variableWidth: false,
                    },
                  },
                  {
                    breakpoint: 425,
                    settings: {
                      slidesToShow: 1,
                      centerMode: true,
                      variableWidth: false,
                    },
                  },
                ],
              }}
            >

              {getLogosData?.map((brand, i) => {
                return (
                  <div className="item" key={i} style={{ width: "300px" }}>
                    <div className="info valign">
                      <div className="cont">
                        <div className="author">
                          <div className="img">
                            <GatsbyImage className="aspect-ratio" loading="lazy"
                              image={brand.brandLogo.localFile?.childImageSharp?.gatsbyImageData}
                              alt={brand?.brandLogo?.altText ? brand?.brandLogo?.altText : brand?.brandName}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

            </Slider>
          </div>
        </div>
        {renderArrows()}
      </div>
    </section>
  );
};

export default LogoCarousel;
